import { Shipment, GetShipmentsByBudget } from '../models';
import { axiosEstimates } from '../../../../utils/api';

export async function getShipments(idBudget: number | string): Promise<Shipment[]> {
  const shipment = await axiosEstimates.get<GetShipmentsByBudget>('/api/v2/shipment-by-budget/' + idBudget);

  return shipment.data.data;
}
